import { ActionBlock } from '@/components/product/ActionBlock';
import { PriceBlock } from '@/components/product/PriceBlock';
import { ProductPropsBadge } from '@/components/product/ProductPropsBadge';
import { ColumnId, ProductListItem } from '@/types';
import { route } from 'ziggy-js';

interface TableCellProps {
    id: ColumnId;
    variation: ProductListItem;
    isInCart: boolean;
    onAddToCart: (p: ProductListItem) => void;
    isAuthenticated: boolean;
    onProductClick: (slug: string) => void;
}

const TableCell = ({ id, variation, isAuthenticated }: TableCellProps) => {
    switch (id) {
        case 'name':
            return (
                <div className="flex items-center gap-3">
                    <a
                        className=" w-14 shrink-0 cursor-pointer overflow-hidden rounded bg-zinc-950"
                        href={route('product', { slug: variation.slug })}
                    >
                        <img
                            src={variation.label}
                            alt={variation.title}
                            loading="lazy"
                            className="h-full w-full object-cover opacity-80 group-hover:opacity-100"
                        />
                    </a>
                    <div className="flex flex-1 flex-col justify-center pl-1">
                        {variation.isNew && (
                            <span className="mb-0.5 inline-flex shrink-0 items-center self-start rounded-sm border border-cyan-600/50 bg-cyan-600 px-1.5 py-0.5 !text-[10px] text-xs font-bold uppercase tracking-wider text-white">
                                New
                            </span>
                        )}
                        {variation.isPromo && (
                            <span className="mb-0.5 inline-flex shrink-0 items-center self-start rounded-sm bg-brand-gold/20 px-1.5 py-0.5 text-[8px] font-bold uppercase tracking-wider text-brand-gold ring-1 ring-inset ring-brand-gold/30">
                                Акция
                            </span>
                        )}
                        <a
                            className="flex-1 cursor-pointer font-['Oswald'] text-base font-bold leading-tight text-zinc-200 transition-colors hover:text-brand-gold"
                            href={route('product', {
                                slug: variation.slug,
                            })}
                        >
                            {variation.name}
                        </a>
                    </div>
                </div>
            );
        case 'brewery':
            return (
                <div>
                    <span className="text-sm font-semibold tracking-wider text-brand-gold opacity-80">
                        {variation.vendor}
                    </span>
                </div>
            );
        case 'style':
            return (
                <span className="inline-flex items-center rounded-md border border-zinc-700 bg-zinc-800/40 px-2 py-0.5 text-[11px] font-medium text-zinc-400">
                    {variation.style}
                </span>
            );
        case 'untappd':
            return (
                variation.untappd && (
                    <ProductPropsBadge
                        value={variation.untappd.score}
                        untappd={true}
                    />
                )
            );
        case 'packaging_type':
            return (
                variation.packaging_type && (
                    <ProductPropsBadge value={variation.packaging_type} />
                )
            );
        case 'volume':
            return (
                variation.volume && (
                    <ProductPropsBadge value={variation.volume + 'л'} />
                )
            );
        case 'props':
            const detailsArray = variation.details
                ? variation?.details.split('|').map((item) => item.trim())
                : [];

            return (
                <div className="flex flex-wrap gap-1">
                    {detailsArray.length > 0 &&
                        detailsArray?.map((item) => (
                            <ProductPropsBadge key={item} value={item} />
                        ))}
                </div>
            );
        case 'price':
            return <PriceBlock variation={variation} />;
        case 'actions':
            return (
                isAuthenticated && (
                    <div className="flex flex-col">
                        <ActionBlock variation={variation} />
                    </div>
                )
            );
        default:
            return <div></div>;
    }
};

export default TableCell;
